import keycloak from '@/keycloak';
import { isLoginInProgress, isLoginThrottled } from '@/auth/loginThrottle';

export const redirectToLogin = (): boolean => {
    if (isLoginInProgress()) return true;
    if (isLoginThrottled(Date.now())) return false;
    keycloak.login();
    return true;
};
